import { FacebookRegularIcon as FacebookIcon } from '@change/ds-icons';

import { ModalHeader, Text } from '@change/ds-core-ui/next';

export function ModalTitle({ onClose }: { onClose: () => void }): JSX.Element {
	return (
		<ModalHeader
			title={
				<div className="flex items-center gap-[8px]">
					<div className="bg-background-base flex h-6 w-6 items-center justify-center rounded-full text-[#1877F2]">
						<FacebookIcon className="h-full w-full" svgClassName="w-full h-full" />
					</div>
					<Text fontWeight="bold" variant="body" size="x-large">
						Your Facebook Post
					</Text>
				</div>
			}
			close={onClose}
		></ModalHeader>
	);
}
